import { render, staticRenderFns } from "./InstagramImage.vue?vue&type=template&id=6855993a&scoped=true"
import script from "./InstagramImage.vue?vue&type=script&lang=js"
export * from "./InstagramImage.vue?vue&type=script&lang=js"
import style0 from "./InstagramImage.vue?vue&type=style&index=0&id=6855993a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6855993a",
  null
  
)

export default component.exports